import React from "react";
import ColumnSort from "../Columns/ColumnSort";
import PropTypes from "prop-types";
import "./style.css";

/**
 * @name Parts
 * @function
 * @description Displays Parts Header
 * @returns {JSX}
 * @param {*} props
 */
const Parts = (props) => {
  return (
    <th className={`header-parts width-150 ${props.className} ${ props.sortStatus === "0" ? "active" : null }`}>
      <div className="header-parts__container">
        <div className="header-parts__container__header-title">{props.value}</div>
        <div className="header-parts__container__header-count">{props.count}</div>
        <ColumnSort name="parts" parameter="0" setSortStatus={props.setSortStatus} />
      </div>
    </th>
  );
};

Parts.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  count: PropTypes.number,
  sortStatus: PropTypes.string,
  setSortStatus: PropTypes.func,
};

export default Parts;
